export default __webpack_public_path__ + "static/logo_nts_informatica-cf1228cbc182e3b8a3faa1b77f7ad299.png";